import { useContext, useState } from 'react'

import { Alert } from '../../new_ui'
import { GlobalContext } from '../../../context'
import { useSignaturesActions } from '../../../hooks'

const SignaturesActions = ({ allChecked, onAllCheckedChange, selectedItems, setSelectedItems, refreshSignatures }) => {
  const { t } = useContext(GlobalContext)
  const { downloadSignatures, deleteSignatures } = useSignaturesActions()
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)

  // On download
  const handleDownload = async (e) => {
    e.preventDefault()
    await downloadSignatures({ selectedDocuments: selectedItems, setSelectedDocuments: setSelectedItems })
  }

  // On delete click
  const handleDeleteClick = (e) => {
    e.preventDefault()
    setShowDeleteAlert(true)
  }

  // On delete
  const handleDelete = async () => {
    await deleteSignatures({ selectedDocuments: selectedItems, setSelectedDocuments: setSelectedItems, setShowDeleteSignatureAlert: setShowDeleteAlert })
    refreshSignatures()
  }

  // On close delete alert
  const handleCloseDeleteAlert = () => {
    setShowDeleteAlert(false)
  }

  return (
    <div className="list-view-v2__actions">
      <div className="checkbox">
        {!allChecked 
          ? <span className="material-symbols-outlined" onClick={onAllCheckedChange}>check_box_outline_blank</span>
          : <span className="material-symbols-outlined filled" onClick={onAllCheckedChange}>check_box</span>
        }
      </div>
      <p className="text-style-1">{t('dashboard.num_of_selected_items', { number: selectedItems.length })}</p>
      <div className="buttons">
        <a href="/#" className="btn btn--primary-light btn--small" onClick={handleDownload}>
          <span className="material-symbols-outlined icon">download</span> 
          <span className="text">{t('general.download')}</span>
        </a>
        <a href="/#" className="btn btn--primary-light btn--small" onClick={handleDeleteClick}>
          <span className="material-symbols-outlined icon">delete</span> 
          <span className="text">{t('general.remove')}</span>
        </a>
      </div>

      {showDeleteAlert && (
        <Alert 
          onClose={handleCloseDeleteAlert} 
          text={t('alert.delete_selected_signatures')}
          deleteAlert={true}
          onSubmit={handleDelete}
        />
      )}
    </div>
  )
}

export default SignaturesActions